module.exports = __webpack_public_path__ + "img/bg-vision.914ae817.jpg";